import React from 'react';
import './Architecture.css';

export default function Architecture() {
  return (
    <section className="arch-section" id="architecture">
      <div className="section-container">
        <div className="section-header">
          <span className="section-badge">Architecture</span>
          <h2 className="section-title">How ARIA Works</h2>
          <p className="section-desc">
            Every ARIA system follows a unified multi-agent architecture with 
            intelligent orchestration, resilient recovery, and full auditability.
          </p>
        </div>
        <div className="arch-grid">
          <div className="arch-card">
            <div className="arch-icon" style={{ background: 'rgba(16, 185, 129, 0.1)', borderColor: 'rgba(16, 185, 129, 0.25)' }}>
              <span>📥</span>
            </div>
            <h3>1. Ingestion</h3>
            <p>Raw documents — transcripts, contracts, tickets, reports — are submitted through the dashboard or API for processing.</p>
          </div>
          <div className="arch-card">
            <div className="arch-icon" style={{ background: 'rgba(34, 211, 238, 0.1)', borderColor: 'rgba(34, 211, 238, 0.25)' }}>
              <span>🔬</span>
            </div>
            <h3>2. Extraction</h3>
            <p>Three specialized extraction agents parse the document in sequence, pulling out entities, events, decisions, and structured data.</p>
          </div>
          <div className="arch-card">
            <div className="arch-icon" style={{ background: 'rgba(167, 139, 250, 0.1)', borderColor: 'rgba(167, 139, 250, 0.25)' }}>
              <span>🧠</span>
            </div>
            <h3>3. Decision</h3>
            <p>Three decision agents evaluate extractions — prioritizing tasks, assigning owners, and determining escalation paths based on severity.</p>
          </div>
          <div className="arch-card">
            <div className="arch-icon" style={{ background: 'rgba(59, 130, 246, 0.1)', borderColor: 'rgba(59, 130, 246, 0.25)' }}>
              <span>🔄</span>
            </div>
            <h3>4. Orchestration</h3>
            <p>The engine coordinates agent execution order, manages state transitions, handles retries, and routes messages between agents intelligently.</p>
          </div>
          <div className="arch-card">
            <div className="arch-icon" style={{ background: 'rgba(249, 115, 22, 0.1)', borderColor: 'rgba(249, 115, 22, 0.25)' }}>
              <span>🛡️</span>
            </div>
            <h3>5. Recovery</h3>
            <p>Circuit breakers protect each agent. If failures exceed thresholds, the circuit opens, preventing cascading failures across the pipeline.</p>
          </div>
          <div className="arch-card">
            <div className="arch-icon" style={{ background: 'rgba(236, 72, 153, 0.1)', borderColor: 'rgba(236, 72, 153, 0.25)' }}>
              <span>📋</span>
            </div>
            <h3>6. Audit Trail</h3>
            <p>Every agent decision, confidence score, and state change is logged immutably — providing full traceability and compliance evidence.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
